import Element from './Element';
import ValidatableMixin from './mixins/ValidatableMixin';
import ValueMixin from './mixins/ValueMixin';
import mixin from 'privates/utils/mixin';

/**
 * @mixin FormElement
 * @summary Provides functionality related to user input elements.
 * @mixes $w.Element
 * @mixes $w.ValidatableMixin
 * @mixes $w.ValueMixin
 * @memberof $w
 */
class FormElement extends Element {}

mixin(FormElement.prototype, ValidatableMixin.prototype);
mixin(FormElement.prototype, ValueMixin.prototype);

export default FormElement;



// WEBPACK FOOTER //
// ./js/modules/ui/FormElement.es6